/**
 * Alertas anti-fraude publicadas en /anti-fraude.
 *
 * Cómo añadir una alerta: agrega un objeto AL PRINCIPIO del array. `date` es opcional
 * (formato "agosto 2026") — úsala solo para alertas de incidentes reales verificados.
 * Las entradas tipo "modalidad" (patrones de estafa conocidos) no llevan fecha.
 * NUNCA publicar nombres de personas; nombres de negocios solo con verificación y visto
 * bueno de Roberto (riesgo legal de difamación).
 */
export interface FraudAlert {
  title: string;
  description: string;
  /** 'modalidad' = patrón de estafa conocido · 'alerta' = incidente activo verificado */
  kind: 'modalidad' | 'alerta';
  date?: string;
}

export const FRAUD_ALERTS: FraudAlert[] = [
  {
    kind: 'modalidad',
    title: 'Perfiles falsos de agencias en redes sociales',
    description:
      'Páginas que copian el nombre y las fotos de una agencia real, ofrecen precios muy por debajo del mercado y piden pago por adelantado a una cuenta personal. Verifica siempre que el perfil enlace a una dirección física real y llama a la agencia por su número publicado antes de pagar.',
  },
  {
    kind: 'modalidad',
    title: 'Cobros por adelantado sin recibo',
    description:
      'Personas que recogen paquetes o cobran "tarifas de aduana" a domicilio en efectivo, sin entregar recibo ni comprobante con el nombre del negocio. Una agencia legítima siempre entrega un recibo con su nombre, su dirección y el detalle de lo cobrado.',
  },
  {
    kind: 'modalidad',
    title: 'Falsos avisos de "paquete retenido"',
    description:
      'Mensajes por WhatsApp o SMS que dicen que tu paquete está retenido y piden un pago para liberarlo, con enlaces a páginas de pago desconocidas. Si envías con una agencia que usa MEC, el estado real de tu envío siempre está en la app Mi Envío Cuba — no en un enlace que te llegue por mensaje.',
  },
  {
    kind: 'modalidad',
    title: 'Reclamos falsos de entrega no recibida',
    description:
      'También existe el fraude contra las agencias: clientes que reclaman no haber recibido un paquete que sí se entregó. Por eso cada entrega hecha con MEC queda comprobada con foto, firma del receptor y GPS — la evidencia protege a las dos partes.',
  },
];
